module.exports = __webpack_public_path__ + "img/ugly_or_beuty_wedding_1.29839bc0.jpg";